import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileData } from '@dxc-technology/halstack-angular';
import { Margin, ModeUpload } from '../types/type';

@Component({
  selector: 'custom-file-input',
  templateUrl: './custom-file-input.component.html',
  styleUrls: ['./custom-file-input.component.scss']
})
export class CustomFileInputComponent implements OnInit {

  @Input() label: string;
  @Input() helperText: string;
  @Input() name: string;
  @Input() mode: ModeUpload = 'file';
  @Input() accept: string;
  @Input() minSize: number;
  @Input() maxSize: number;
  @Input() tabIndexValue: number;
  @Input() multiple: boolean = true;
  @Input() showPreview: boolean = false;
  @Input() disabled: boolean = false;
  @Input() margin: Margin = 'medium';
  @Input() files: Array<FileData> = [];
  @Output() onUpload = new EventEmitter<any>();

  constructor() {
    //Constructor
  }

  ngOnInit(): void {
    //onInit
  }

  async onFileInput(event) {
    console.log("eventfileUpload", event);
    if(event.length != 0){
      this.onUpload.emit(event);
    }
  }

}
